import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueBreadcrumbs from 'vue-2-breadcrumbs'
import './assets/styl/main.styl'
import Multiselect from 'vue-multiselect'
import Axios from 'axios'
import vSelect from 'vue-select'
import VuePapaParse from 'vue-papa-parse'

Vue.use(VuePapaParse)

Vue.component('v-select', vSelect)
Vue.component('multiselect', Multiselect)

Axios.defaults.baseURL = process.env.VUE_APP_API

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueBreadcrumbs, {
  template:
    '        <nav v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '            <ol class="am_breadcrumb">\n' +
    '                <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" class="breadcrumb-item active" aria-current="page">\n' +
    '                    <router-link :to="{ path: getPath(crumb) }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
    '                </li>\n' +
    '            </ol>\n' +
    '        </nav>'
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && to.path !== '/contrasena') {
    const token = localStorage.getItem('token')
    if (token == null) {
      next('login')
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
